<template>
    <div>
        <b-modal id="edit_project_modal" @ok="edit_project">
            <template slot="modal-title">Edit a project</template>
            <form ref="edit_project_form">
                <b-form-group
                        label="Project name"
                        label-for="name">
                    <b-form-input
                            id="name"
                            :state="validateName"
                            v-model="selected_project.name"
                            autofocus
                            required/>
                    <b-form-invalid-feedback :state="validateName">
                        Project name is invalid, it needs at least {{minNameLength}} characters.
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                        label="User"
                        label-for="user">
                    <b-form-select
                            id="user"
                            :state="validateUser"
                            v-model="selected_project.user_id"
                            :options="user_options"
                            required/>
                    <b-form-invalid-feedback :state="validateUser">
                        Select a User.
                    </b-form-invalid-feedback>
                </b-form-group>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import ProjectRepository from '../../repositories/project.repository';

    export default {
        props: {
            selected_project: {
                type: Object,
                default: ProjectRepository.blankProject,
            },
            user_options: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {minNameLength: process.env.VUE_APP_VALIDATION_PROJECT_MIN_NAME_LENGTH}
        },
        methods: {
            checkFields() {
                if (ProjectRepository.validate.projectName(this.selected_project.name) === false) return false;
                if (ProjectRepository.validate.user(this.selected_project.user_id) === false) return false;
                return true;
            },
            edit_project(modal) {
                if (this.$refs.edit_project_form.checkValidity() && this.checkFields()) {
                    this.$emit('show-loading-pop-up', 'Saving the changes to the selected project');
                    ProjectRepository.put(this.selected_project.id, this.selected_project).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('project-edited', res.data);
                        // Notify the user.
                        this.$bvToast.toast(`Project ${res.data.name} successfully edited.`, {
                            title: `Project edited.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$emit('reset-loading-pop-up');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new project. Check the value\'s of all the fields', {
                                title: `Project creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while creating a new project.', {
                                title: `Project creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateName() {
                return ProjectRepository.validate.projectName(this.selected_project.name);
            },
            validateUser() {
                return ProjectRepository.validate.user(this.selected_project.user_id);
            }
        }
    }
</script>
